import React from "react";
import { Box, useTheme } from "@material-ui/core";
import Text from "../../../../../shared/components/Text";
import IconTitle from "../../../../../shared/components/IconTitle";
import { assetIds, ThemedAsset } from "nemuru-components";
import { ICON_TITLE_HEIGHT } from "../../../../../../config/config";
import { QuotaSummary } from "./components/shared/QuotaSummary";
import { PaymentGateway } from "./components/PaymentGateway/PaymentGateway";
import { PaymentPlanLineStatus } from "@nemuru-eng/js-api-client";
import { PaymentPlanLineResultMessage } from "./components/shared/PaymentPlanLineResultMessage";

export const PaymentPlanLine = ({
  paymentPlan,
  currentPaymentPlanLine,
  navigateToPaymentPlan,
}) => {
  const { palette } = useTheme();

  return (
    <>
      <Box
        className={"appear-anim"}
        position={"relative"}
        display={"flex"}
        flexDirection={"column"}
        alignItems={"center"}
      >
        <Box my={1}>
          <IconTitle
            title={<Text tId={"YOUR_INSTALMENT"} />}
            subtitle={<Text tId="INSTALMENT_DETAIL" />}
            icon={
              <ThemedAsset
                id={assetIds.ICON_LOAN}
                width={ICON_TITLE_HEIGHT}
                height={ICON_TITLE_HEIGHT}
                style={{ color: palette.secondary.main }}
              />
            }
          />
        </Box>
        <QuotaSummary
          paymentPlan={paymentPlan}
          paymentPlanLine={currentPaymentPlanLine}
          navigateToPaymentPlan={navigateToPaymentPlan}
        />
      </Box>
      <Box flexGrow={1} display={"flex"} flexDirection={"column"}>
        {currentPaymentPlanLine.status === PaymentPlanLineStatus.PENDING ? (
          <PaymentGateway paymentPlanLine={currentPaymentPlanLine} />
        ) : (
          <Box
            mb={4}
            flexGrow={1}
            display={"flex"}
            flexDirection={"column"}
            justifyContent={"flex-end"}
          >
            <PaymentPlanLineResultMessage
              paymentPlanLine={currentPaymentPlanLine}
            />
          </Box>
        )}
      </Box>
    </>
  );
};
